import { useMutation, useQuery } from "@tanstack/react-query";
import apiSauce from "../../config/apisauce";
import { route } from "../../../../vendor/tightenco/ziggy/src/js";

export const useSuspension = (suspensionId, enabled = true) => {
  return useQuery({
    queryKey: ["suspension", suspensionId],
    queryFn: async () => {
      const response = await apiSauce.get(route("showSuspension", { suspension: suspensionId }));
      return response.data;
    },
    enabled: !!suspensionId && enabled,
  });
};
